import { useEffect } from 'react'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../constants/validation'
import { SERVER_NON_FIELD_ERROR } from '../../Form.constants'

export function useFormServerNonFieldNotification({
  errors,
  removeNotification,
  setNotification,
}) {
  useEffect(() => {
    if (errors?.[SERVER_NON_FIELD_ERROR_KEY]) {
      setNotification?.({
        id: SERVER_NON_FIELD_ERROR,
        text: errors[SERVER_NON_FIELD_ERROR_KEY],
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      removeNotification?.(SERVER_NON_FIELD_ERROR)
    }
  }, [errors])
}
